import {Excursion} from "@/services/excursions/types";

export abstract class IFilter {

    public name: string;
    public key: keyof Excursion;
    public symbol = "";

    protected constructor(name: string, key: keyof Excursion) {
        this.name = name;
        this.key = key;
    }

    abstract initialize(excursions: Excursion[]): boolean;
    abstract test(excursion: Excursion): boolean;
    abstract to_string(): string;
    abstract from_string(value: string): void;
    abstract changed(): boolean;
    abstract reset(): void;

    setSymbol(symbol: string){
        this.symbol = symbol;
    }
}